export default class LoyaltyLandingPage {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-landing-page");

    if (!this.$el) {
      return;
    }

    this.state = "mobile";

    this.$mobileImage = this.$el.querySelector(
      ".js-loyalty-landing-page-mobile-image"
    );
    this.$desktopImage = this.$el.querySelector(
      ".js-loyalty-landing-page-desktop-image"
    );
    this.$toggle = this.$el.querySelector(".js-loyalty-landing-page-toggle");

    this.$toggle.addEventListener("click", this.toggle.bind(this));
    this.updateState(true);
  }

  toggle() {
    this.$toggle.classList.toggle("is-active");
    this.updateState();
  }

  updateState(firstRun = false) {
    if (firstRun) {
      this.$mobileImage.classList.remove("is-hidden");
      this.$desktopImage.classList.add("is-hidden");
      return;
    }

    if (this.state === "mobile") {
      this.$mobileImage.classList.add("is-hidden");
      this.$desktopImage.classList.remove("is-hidden");
      this.state = "desktop";
    } else {
      this.$mobileImage.classList.remove("is-hidden");
      this.$desktopImage.classList.add("is-hidden");
      this.state = "mobile";
    }
  }
}
